import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import { RecordsKeeperAIBreadCrumbs } from '../core/_constants'
import FileSection from '../components/RecordsAndFiles/FileSection'
import { Link, useNavigate } from 'react-router-dom'
import RequestFileModal from '../components/RecordsAndFiles/RequestFileModal'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { useThemeMode } from '../../../../_metronic/partials'
import RecordsKeeperAIGenerator from '../components/RecordsKeeperAIGenerator'
import { useUpdateSettingsData } from '../../../hooks/updateSettingsData'
import { toast } from 'react-toastify'
import { allowedFileTypes } from '../../../core/_constants'
import { FileUpload } from '../../widgets/components/FileUpload'
import { Dropdown } from 'react-bootstrap'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
// import { useAuth } from '../../auth'
// import SyncStorage from '../components/RecordsAndFiles/SyncStorage'
// import AIGeneratedInsights from '../components/RecordsAndFiles/AIGeneratedInsights'

const RecordsAndFiles = () => {
  const { formatMessage } = useIntl()
  // const { planStatus } = useAuth()
  const { mode } = useThemeMode()
  const navigate = useNavigate()
  const [isModalActive, setIsModalActive] = useState(false)
  const [modalStatus, setModalStatus] = useState(false)

  const { updateSettings } = useUpdateSettingsData()
  useEffect(() => {
    updateSettings()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <PageTitle
        breadcrumbs={RecordsKeeperAIBreadCrumbs}
        description={formatMessage({ id: 'Records & FIles' })}
      >
        {formatMessage({ id: 'RecordsKeeper AI' })}
      </PageTitle>
      {/* button for desktop view */}
      <div
        // className={`d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block w-25 ${planStatus === 'payment_due' && 'planstatus-adjustment'} ${planStatus === 'paid' && 'planstatus-not-adjustment'}`}>
        className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
        style={{ top: '80px', right: '30px' }}>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end gap-4 align-items-center'>
            {/* <Link to='/rk/records-and-files/archieved-files'
              className='font-size-13 text-primary font-weight-400 w-100 text-nowrap'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Archived Documents' })}
            </Link> */}
            <button
              type='button'
              className='btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100 text-nowrap d-flex align-items-center justify-content-center height-36'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Upload Files' })}
            </button>
            <button
              className={
                `btn w-100 d-flex justify-content-center font-size-13 text-nowrap font-weight-400 custom-button-property d-flex align-items-center height-36 ` +
                (mode === 'dark'
                  ? `btn-outline-primary btn-no-hover-dark`
                  : `btn-outline-primary bg-new-conv-btn btn-no-hover`)
              }
              onClick={() => navigate('/rk/records-and-files/files-request')}
            >
              {formatMessage({ id: 'File Request' })}
            </button>
            <div className='d-flex align-items-center position-relative'>
              <div className='dropdown-export-container'>
                <Dropdown className='height-36'>
                  <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                    <img src={threeDots} alt='' className='three-dots-image' />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className='m-1 rounded'>
                    {/* <Dropdown.Item
                      className='text-dark ps-5 rounded-top border-bottom'
                    >
                      <Link to='/rk/records-and-files/archieved-files' className='text-dark'>
                        {formatMessage({ id: 'Archived Records' })}
                      </Link>
                    </Dropdown.Item> */}
                    <Dropdown.Item
                      className='text-dark ps-5 rounded'
                    >
                      <Link to='/rk/overview/recent-uploads' className='text-dark'>
                        {formatMessage({ id: 'Recent Uploads' })}
                      </Link>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* button for mobile view */}
      <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none px-6'>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex flex-column align-items-center w-100 w-md-auto gap-2 mb-4 mb-md-auto'>
            {/* <Link to='/rk/records-and-files/archieved-files'
              className='font-size-13 text-primary text-center font-weight-400 w-100 text-nowrap'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Archived Documents' })}
            </Link> */}
            <button
              type='button'
              className='btn bg-primary font-size-13 text-white mb-md-4 mb-0 font-weight-400 w-100 custom-button-property'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Upload Files' })}
            </button>
            <div className='d-flex w-100 gap-2 align-items-center'>
              <button
                className={
                  `btn px-2 py-3 w-100 custom-button-property ` +
                  (mode === 'dark'
                    ? `btn-outline-primary btn-no-hover-dark`
                    : `btn-outline-primary btn-hover-primary bg-new-conv-btn btn-no-hover`)
                }
                onClick={() => setIsModalActive(true)}
              >
                {formatMessage({ id: 'File Request' })}
              </button>
              <div className='d-flex align-items-center position-relative'>
                <div className='dropdown-export-container'>
                  <Dropdown className='height-40'>
                    <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                      <img src={threeDots} alt='' className='three-dots-image' />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className='m-1 rounded'>
                      {/* <Dropdown.Item
                        className='text-dark ps-5 rounded-top border-bottom'
                      >
                        <Link to='/rk/records-and-files/archieved-files' className='text-dark'>
                          {formatMessage({ id: 'Archived Records' })}
                        </Link>
                      </Dropdown.Item> */}
                      <Dropdown.Item
                        className='text-dark ps-5 rounded'
                      >
                        <Link to='/rk/overview/recent-uploads' className='text-dark'>
                          {formatMessage({ id: 'Recent Uploads' })}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        isModalActive && (
          <RequestFileModal isModalActive={isModalActive} setIsModalActive={setIsModalActive} />
        )
      }
      <div className='px-6 mb-8 position-relative'>
        <div>
          <InfoCard2
            title={'Managing Your Records & Files'}
            desc={
              'This page allows you to organize, manage, and access all your files and records. You can easily navigate through folders, upload new documents, or request files. Use the actions menu to share, modify, or view recent visits to each file. Explore the various sections for more detailed document management.'
            }
            slug={
              'https://help.recordskeeper.ai/en/articles/10368029-how-to-manage-your-records-and-files-on-recordskeeper-ai-for-seamless-records-management#h_aae9b85dc8 '
            }
          />
          <RecordsKeeperAIGenerator />
        </div>
        <FileSection />
        <FileUpload
          fileSize={parseInt(process.env.REACT_APP_RK_MAX_ZIP_FILE_SIZE as string)}
          maxFileNumber={10}
          allowType={allowedFileTypes}
          metaData={{ module: 'document', isProtected: false }}
          modalStatus={modalStatus}
          handleClose={() => {
            setModalStatus(false)
          }}
          handleSuccess={(id: number, name: string) => {
            toast.success(
              `${name
                .split('/')
                .pop()} uploaded successfully! Please wait for 1-2 minutes while the file is processed with AI. After that you can check the "Records & Files" section or "Overview" section`
            )
          }}
          resourceType='all'
          assemblyOption='rk-doc-upload'
        />
        {/* <div className='position-absolute end-0 bottom-0'>
          <AIGeneratedInsights />
          <SyncStorage />
        </div> */}
      </div>
    </div >
  )
}

export default RecordsAndFiles
